import React from 'react';
import { WorkflowCanvasInspector } from './workflow-canvas-inspector';
import { ArtifactDrillProvider } from './workflow-drill-context';
import type { DrillTarget } from './workflow-drill-context';
import { WorkflowDrillDetail } from './workflow-drill-detail';

/**
 * A node or trigger's config, in the canvas inspector.
 *
 * No `header` — `WorkflowEditPanel` (via `layout="inspector"`) draws its own,
 * with the node's icon, title, badge and close button. See
 * {@link WorkflowCanvasInspector} for why the panel floats rather than splitting
 * the layout.
 */
export const WorkflowEditorInspector: React.FC<{
  target: DrillTarget;
  onClose: () => void;
}> = ({ target, onClose }) => (
  <WorkflowCanvasInspector open={target !== null} onClose={onClose}>
    <ArtifactDrillProvider target={target} onClose={onClose}>
      <WorkflowDrillDetail target={target} layout="inspector" />
    </ArtifactDrillProvider>
  </WorkflowCanvasInspector>
);
